import React from 'react'
import { Form } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import RequieredInputs from '../common/RequiredInputs'

const ProfileForm = (
    {
        inputs,
        handleChange,
        isDisable,
        textBtn,
        handleSubmit
    }
) => {

    const colors = useSelector(state => state.colors)

    return (
        <div className="task__container">
            <Form className="form-align_text_center"
                onSubmit={handleSubmit}
            >
                <div className="row col-12 form__container">
                    <div className="col-12 col-md-9">
                        <Form.Group size="lg">
                            <Form.Label className="form__labels">Nombre y Apellidos <RequieredInputs/></Form.Label>
                            <Form.Control
                                name="nombre"
                                className="user-input form__input"
                                type="text"
                                value={inputs.nombre}
                                onChange={handleChange}
                                placeholder="Nombre y Apellidos"
                            />
                        </Form.Group>
                    </div>
                    <div className="col-12 col-md-5 col-lg-3">
                        <Form.Group size="lg">
                            <Form.Label className="form__labels">Teléfono</Form.Label>
                            <Form.Control
                                className="user-input form__input"
                                type="text"
                                name="telefono"
                                minLength="9"
                                value={inputs.telefono}
                                onChange={handleChange}
                                placeholder="Teléfono"
                            />
                        </Form.Group>
                    </div>
                    <div className="col-12 col-md-3">
                        <Form.Group size="lg">
                            <Form.Label className="form__labels">Email <RequieredInputs/></Form.Label>
                            <Form.Control
                                className="user-input form__input"
                                type="email"
                                name="email"
                                value={inputs.email}
                                onChange={handleChange}
                                placeholder="Email"
                            />
                        </Form.Group>
                    </div>
                    {
                        inputs.tipoColores !== null ?
                        <div className="col-12 col-md-3">
                        <Form.Group size="lg">
                            <Form.Label className="form__labels">Color de Fondo</Form.Label>
                            <Form.Control
                                as="select" className="user-input form__input"
                                type="text"
                                name="id_TipoColor"
                                value={inputs.id_TipoColor}
                                onChange={handleChange}
                                placeholder="Color"
                            >
                                <option value="">Elegir Color </option>
                                {
                                    colors.length > 0 ? colors.map((color, i) =>
                                        <option
                                            key={i}
                                            value={color.id_TipoColor}
                                        >
                                            {color.nombreColor}
                                        </option>
                                    ) : null
                                }
                            </Form.Control>
                        </Form.Group>
                    </div>
                        : null
                    }
                    <div className="col-12 col-md-3">
                            <Form.Label className="form__labels">Rol </Form.Label>
                            <div className="readOnly" readOnly> {inputs.roles.nombre}</div>
                    </div>
                    {
                        inputs.tipoZonas !== null ?
                        <div className="col-12 col-md-3">
                            <Form.Label className="form__labels">Zona </Form.Label>
                            <div className="readOnly" readOnly> {inputs.tipoZonas.nombre}</div>
                        </div>
                        : null
                    }

                </div>
                 <button
                    disabled={isDisable}
                    onClick={handleSubmit}
                    className="btn save"
                >
                    {textBtn}
                </button>
                {
                    isDisable &&
                    <Form.Label className="alert_validation">*Campos obligatorios no informados y/o con formato incorrecto.</Form.Label>
                }
            </Form>
        </div>
    )
}

export default ProfileForm